import React, { useEffect, useState } from "react";
import Downloadapp from "./Downloadapp";
import Security from "./Security";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";
import axios from "axios";

const Contact_us = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/contact_us`,
      );
      console.log(res);
      setData(res.data.data[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <div>
        {/* header section start */}
        {/* Modal */}
        <div className="modal fade offcanvas-modal" id="exampleModal">
          <div className="modal-dialog offcanvas-dialog">
            <div className="modal-content">
              <Manubar />
            </div>
          </div>
        </div>
        <header>
          {/* header top end */}
          <Shearchbar />
          {/* header middle end */}
          <Navbar />
          {/* header middle end */}
        </header>
        {/* header section end */}
        {/* main content start */}
        {/* bread crumb section start */}
        <nav className="breadcrumb-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    contact us{" "}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </nav>
        {/* bread crumb section end */}
        <div className="map section-mb">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d64876600.99126343!2d-31.49658015000001!3d-7.0382327499999855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x65a81cae36eb8ff%3A0xa6342257f310534f!2sAtlantic%20Ocean!5e0!3m2!1sen!2sbd!4v1618893629132!5m2!1sen!2sbd" />
        </div>
        <section className="contact-section section-mb">
          <div className="container">
            <div className="row mb-n7">
              <div className="col-lg-6 mb-7">
                {/* contact-title-section start */}
                <div className="contact-title-section">
                  <h3 className="title">Get in touch</h3>
                  <p>
                    Top rated construction packages we pleasure rationally
                    encounter
                    <br className="d-none d-xl-block" />
                    consequences interesting who loves or pursue or desires
                  </p>
                </div>
                {/* contact-title-section end */}
                <form
                  id="contactForm"
                  className="row"
                  action="https://htmldemo.net/grano/grano/assets/php/contact.php"
                  method="POST"
                  noValidate="novalidate"
                >
                  {/* assets/php/contact.php */}
                  <div className="col-12 col-sm-6 mb-7">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Your Name*"
                    />
                  </div>
                  <div className="col-12 col-sm-6 mb-7">
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="Your Email*"
                    />
                  </div>
                  <div className="col-12 mb-9">
                    <textarea
                      className="form-control massage-control"
                      name="massage"
                      id="massage"
                      cols={30}
                      rows={10}
                      placeholder="Message"
                      defaultValue={""}
                    />
                  </div>
                  <div className="col-12">
                    <button
                      id="contactSubmit"
                      type="submit"
                      className="btn btn-dark"
                    >
                      Send Message
                    </button>
                    <p className="form-message mt-3" />
                  </div>
                </form>
              </div>
              <div className="col-lg-6 mb-7">
                <div className="contact-address">
                  {/* address-list start */}
                  <div className="address-list mb-4 mb-xl-10 pb-2">
                    <h4 className="title">Office Addres</h4>
                    <p>
                      245 Southern Street, Apartment no. 174 Central Twon, New
                      Yourk, USa
                    </p>
                  </div>
                  {/* address-list end */}
                  {/* address-list start */}
                  <div className="address-list mb-4 mb-xl-10 pb-2">
                    <h4 className="title">Phone Number</h4>
                    <ul>
                      <li>
                        <a className="phone-number" href="tel:+12345678987">
                          {data?.contact_no}
                        </a>
                      </li>

                      <li>
                        <a className="phone-number" href="tel:+12345678987">
                          {data?.whatsup_no}
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                  {/* address-list end */}
                  {/* address-list start */}
                  <div className="address-list">
                    <h4 className="title">Web Address</h4>
                    <ul>
                      <li>
                        <a className="mailto" href="mailto:info@example.com">
                          {data?.email}
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                  {/* address-list end */}
                </div>
              </div>
            </div>
          </div>
        </section>
        <Security />
        <Footer />
      </div>
    </div>
  );
};

export default Contact_us;
